<template>
    <div>
        <v-dialog v-model="openConfirm" persistent width="400" class="align-center">
            <template>
                <v-card height="160">
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Guardar cambios</v-toolbar-title>
                </v-toolbar>
                    <v-form ref="form" class="text-center mt-3">
                        ¿Seguro que desea guardar los cambios realizados?
                    </v-form>
                    <div align="right" class="align-content-end mx-4 mt-3">
                        <v-btn color="accent" 
                            small
                            class="white--text mx-2"
                            @click="confirmSave"
                            >Guardar
                        </v-btn>
                        <v-btn color="blue-grey lighten-1" 
                            small 
                            class="white--text" 
                            @click="close"
                            >Cancelar
                        </v-btn>
                    </div>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'formConfirmation',
    props: ['openConfirm','meter_id'],
    methods: {
        confirmSave(){
            this.$emit('saveFunction')
        },
        close(){
            this.$emit('close')
        },
        refreshPage(){
            window.location.reload()
        }
    },
}
</script>>